import {
    AnnouncedRecordList,
    FLIGHT_REQUEST_LIST_SUCCESS,
    FLIGHT_REQUEST_LIST_FAILURE,
    FlightRequestsListState,
    GET_ANNOUNCEMENT_LIST_SUCCESS,
    FlightRequestsActionTypes,
    HiddenColumnsState,
    ColumnsOrderState,
    CHANGE_HIDDEN_COLUMNS,
    CHANGE_HIDDEN_COLUMNS_ALL,
    CHANGE_SELECTED_REQUESTS,
    CHANGE_SELECTED_REQUESTS_ALL,
    SelectedRequestsState,
    SelectedFiltersState,
    CHANGE_SELECTED_FILTERS,
    CHANGE_SELECTED_FILTERS_ALL,
    CHANGE_COLUMNS_ORDER,
    CHANGE_COLUMNS_ORDER_ALL,
    FLIGHT_STATUS_SUCCESS
} from './types';

const flightRequestsListInitialState: FlightRequestsListState = {
    data: [],
    total: 0,
};
export function getAllFlightRequests(state = flightRequestsListInitialState, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case FLIGHT_REQUEST_LIST_SUCCESS:
            return action.payload;
        case FLIGHT_REQUEST_LIST_FAILURE:
            return action.payload;
        default:
            return state;
    }
}
const announcedRecordsListInit: AnnouncedRecordList = {
    rows: [],
    rowCount: 0,
};
export function announcedRecordsList(state = announcedRecordsListInit, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case GET_ANNOUNCEMENT_LIST_SUCCESS:
            return action.payload.data;
        default:
            return state;
    }
}

const hiddenColumnsInit: HiddenColumnsState = {};

export function hiddenColumns(state = hiddenColumnsInit, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case CHANGE_HIDDEN_COLUMNS:
            return Object.assign({}, state, {
                ...state, [action.requestPayload?.id as string]: action.payload.data
            })
        case CHANGE_HIDDEN_COLUMNS_ALL:
            return action.payload.data;
        default:
            return state;
    }
}

const columnsOrderInit: ColumnsOrderState = {};
export function columnsOrder(state = columnsOrderInit, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case CHANGE_COLUMNS_ORDER:
            return Object.assign({}, state, {
                ...state, [action.requestPayload?.id as string]: action.payload.data
            })
        case CHANGE_COLUMNS_ORDER_ALL:
            return action.payload.data;
        default:
            return state;
    }
}

const selectedFiltersInit: SelectedFiltersState = {};

export function selectedFilters(state = selectedFiltersInit, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case CHANGE_SELECTED_FILTERS:
            return Object.assign({}, state, {
                ...state, [action.requestPayload?.id as string]: action.payload.data
            })
        case CHANGE_SELECTED_FILTERS_ALL:
            return action.payload.data;
        default:
            return state;
    }
}

const selectedRequestsInit: SelectedRequestsState = {};

export function selectedRequests(state = selectedRequestsInit, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case CHANGE_SELECTED_REQUESTS:
            return Object.assign({}, state, {
                ...state, [action.requestPayload?.id as string]: action.payload.data
            })
        case CHANGE_SELECTED_REQUESTS_ALL:
            return action.payload.data;
        default:
            return state;
    }
}

export function statusTranslation(state = {}, action: FlightRequestsActionTypes) {
    switch (action.type) {
        case FLIGHT_STATUS_SUCCESS:
            return action.payload.data;
        default:
            return state;
    }
}